import { render, staticRenderFns } from "./ObjectSearchDetail.vue?vue&type=template&id=a876f3da"
import script from "./ObjectSearchDetail.vue?vue&type=script&lang=js"
export * from "./ObjectSearchDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports